import { TextField, Datagrid, Title, useRecordContext } from "react-admin";
import { VpnKey } from "@mui/icons-material";
import { Box } from "@mui/material";
import { LocalDataGrid } from "../ra-lb-tools/components/LocalDatagrid";
import { useMyContext } from "../ra-lb-tools/components/myContext";
import get from "lodash/get";
import { Row } from "../ra-lb-tools/components/row";
import { ClearLocalSettingsButton } from "../ra-lb-tools/components/cleanLocalSettingsButton";

export const PermissionIcon = VpnKey;

function flattenToRows(obj, columnNames, valueName = "value", prefix = []) {
  let rows = [];
  for (const [key, value] of Object.entries(obj)) {
    const newPath = [...prefix, key];
    if (
      typeof value === "object" &&
      value !== null &&
      !Array.isArray(value) &&
      newPath.length < columnNames.length
    ) {
      rows = rows.concat(flattenToRows(value, columnNames, valueName, newPath));
    } else {
      const row = {};
      newPath.forEach((segment, i) => {
        row[columnNames[i] || `level${i + 1}`] = segment;
      });
      row[valueName] = value;
      rows.push(row);
    }
  }
  return rows;
}

const FieldList = ({ source }) => {
  const record = useRecordContext();
  const list = get(record, `schemas.${source}`);
  if (!list) {
    return <Box>No info</Box>;
  }
  if (!list.length) return null;

  return (
    <Box className="FieldList">
      <Box className="FieldListSummary">{list.length} fields:</Box>
      <Box className="FieldListContainer">
        {list.map((i, idx) => (
          <Box className="FieldListItem" key={idx}>
            {i}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export const PermissionList = () => {
  const { acp } = useMyContext();

  const permissions = acp.permissions
    .map((perm, idx) => ({
      id: idx,
      ...perm,
    }))
    .sort((a, b) => a.action.localeCompare(b.action));

  const actions = flattenToRows(
    acp.getCommands(),
    ["domain", "model"],
    "commands"
  );
  const schemas = flattenToRows(
    acp.actions,
    ["domain", "model", "command"],
    "schemas"
  );

  const preSx = {
    margin: "8px 24px",
    padding: "5px",
    backgroundColor: "white",
    whiteSpace: "pre-wrap",
  };

  return (
    <Box>
      <Title title={"Permissions"} />
      <Row
        sx={{
          justifyContent: "space-between",
          padding: "20px 0",
          ">*": { margin: 0 },
        }}
      >
        <h2>Enforcer Version: {acp.info.enforcerVersion}</h2>
        <ClearLocalSettingsButton label="Reload permissions" />
      </Row>
      <h3>Permissions</h3>
      <Datagrid
        resource="permissions"
        data={permissions}
        total={permissions.length}
        bulkActionButtons={false}
        sort={{}}
      >
        <TextField source="type" />
        <TextField source="subj" />
        <TextField source="resource" />
        <TextField source="action" />
        <TextField source="domain" />
        <TextField source="model" />
        <TextField source="command" />
      </Datagrid>
      <h3>Allowed actions</h3>
      <LocalDataGrid data={actions} bulkActionButtons={false} sort={{}}>
        <TextField source="domain" />
        <TextField source="model" />
        <TextField source="commands" />
      </LocalDataGrid>
      <h3>Action schemas</h3>
      <LocalDataGrid data={schemas} bulkActionButtons={false} sort={{}}>
        <TextField source="domain" />
        <TextField source="model" />
        <TextField source="command" />
        <FieldList source="request_fields" />
        <FieldList source="response_fields" />
        <FieldList source="filters" />
      </LocalDataGrid>
      <h3>Roles</h3>
      <pre style={preSx}>{acp.roles.join(", ")}</pre>
      <h3>PERM Model</h3>
      <pre style={preSx}>{acp.info.model}</pre>
      <h3>Policies</h3>
      <pre style={preSx}>{acp.info.adapter}</pre>
    </Box>
  );
};
